import * as model from "../models";
import { BoxOfficeActions, EventCategoryActions } from "../actions"

export interface EventCategoryState {
	eventCategories: model.EventCategory[];
	currentEventCategory: model.EventCategory
};

const initialState: EventCategoryState  = {
	eventCategories: [],
	currentEventCategory: null
}

export const eventCategoryReducer = (state: EventCategoryState = initialState, action): EventCategoryState => {
	switch (action.type) {
		case EventCategoryActions.CLEAR_STATE:
		case BoxOfficeActions.CLEAR_EVENTSERVER_STATE:
			return initialState;

		case EventCategoryActions.EVENT_CATEGORIES_LOADED:
			return Object.assign({}, state, { eventCategories: action.payload })

		case EventCategoryActions.EVENT_CATEGORY_LOADED:
			return Object.assign({}, state, { currentEventCategory: action.payload })

		default: return state
	}
}



// WEBPACK FOOTER //
// ./src/app/reducers/event-category.reducer.ts